const collectionSwiper = new Swiper('.collection-swiper', {
  loop: true,
  slidesPerView: 'auto',
});

const lifestyleSwiper = new Swiper('.lifestyle-swiper', {
  loop: false,
  slidesPerView: 'auto',
  spaceBetween: 10,
});

const productSwiper = new Swiper('.product-swiper', {
  loop: true,
  slidesPerView: 'auto',
  spaceBetween: 20,
  // breakpoints: {
  //   1800: {
  //     slidesPerView: 7
  //   }
  // }
});
